// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"d66ca1a6","225":"3efcd078","588":"14aa0450","873":"4f5de905","905":"7311498b","941":"94a6fc3c"}[chunkId] + ".chunk.js";
};